import { gql } from 'apollo-angular';

// #746: Job-Verwaltung. Backend liefert die Felder mit "get"-Praefix (getJobGroups, getJobDetails,
// getJobDetail) — abweichend vom Issue-Text, der die bloße Form (jobGroups, ...) verwendet. Das hier
// ist die tatsaechlich live Schema-Form in scheduler.graphqls.

/** Nur die Gruppen — einmalig auf Seitenaufruf geladen, unabhaengig von der Gruppenwahl. */
export const JOB_GROUPS_QUERY = gql`
  query getJobGroups {
    getJobGroups
  }
`;

export interface JobGroupsResponse {
  getJobGroups: string[];
}

/**
 * Job-Liste einer Gruppe. Laeuft nur nach Gruppenwahl (Spec §4.1) — group ist deshalb non-null
 * deklariert, obwohl das Schema-Feld selbst group optional erlaubt.
 *
 * jobTriggers traegt hier bewusst KEIN commands: die Liste zeigt keine Command-Buttons, nur das
 * Job-Detail tut das (Spec §6).
 */
export const JOB_DETAILS_QUERY = gql`
  query getJobDetails($group: String!) {
    getJobDetails(group: $group) {
      key { name group }
      description
      jobClass
      jobTriggers {
        key { name group }
        nextFireTime
        triggerState
      }
    }
  }
`;

export interface JobKeyPayload {
  name: string;
  group: string;
}

export interface TriggerListItemPayload {
  key: JobKeyPayload;
  nextFireTime: string | null;
  triggerState: string;
}

export interface JobDetailListItemPayload {
  key: JobKeyPayload;
  description: string | null;
  jobClass: string;
  jobTriggers: TriggerListItemPayload[];
}

export interface JobDetailsResponse {
  getJobDetails: JobDetailListItemPayload[];
}

/**
 * Einzelner Job fuers Detail — inklusive Commands je Job und je Trigger. CommandTemplate ist im
 * Schema ein `scalar` (kein Typ), daher ohne Unterauswahl abgefragt; das Backend liefert direkt das
 * JSON-Objekt {name, settings, parameters, flow}.
 */
export const JOB_DETAIL_QUERY = gql`
  query getJobDetail($group: String!, $name: String!) {
    getJobDetail(group: $group, name: $name) {
      key { name group }
      description
      jobClass
      commands
      jobTriggers {
        key { name group }
        nextFireTime
        previousFireTime
        triggerState
        commands
      }
    }
  }
`;

export interface TriggerDetailPayload {
  key: JobKeyPayload;
  nextFireTime: string | null;
  previousFireTime: string | null;
  triggerState: string;
  commands: any[] | null;
}

export interface JobDetailPayload {
  key: JobKeyPayload;
  description: string | null;
  jobClass: string;
  commands: any[] | null;
  jobTriggers: TriggerDetailPayload[];
}

export interface JobDetailResponse {
  getJobDetail: JobDetailPayload | null;
}
